<template>
	<div name="hres6ju-popup" id="hres6ju-popup" class="modal fade" role="dialog">
		<div class="modal-dialog modal-lg">
	    <div class="modal-content">
	      <div class="modal-header header-popup">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">{{ labels['HRES6JUC4']['10'] }}</h4>
        </div>

        <div class="modal-body detail detail-responsive">
					<div class="box-body">
						<div class="row">
			        <div class="col-xs-6 col-md-6 input-half-left">
			          <div class="form-group ">
			            <label>{{ labels['HRESH6XC1']['10'] }} :</label>
			            <input type="text" id="coddesc_codempid" name="coddesc_codempid" class="form-control " readonly="readonly" v-model="descCodemid" />
			          </div>
			        </div>
			        <div class="col-xs-6 col-md-5 input-half-right">
			          <!-- <div class="form-group">
			            <label>{{ labels['HRESH6XC1']['20'] }} :</label>
			          	<hrms-dropdown v-model="codtparg" :options="arrCodtparg[nowLang]" />			       
			          </div> -->

			          <div class="form-group">
			          	<label>{{ labels['HRESH6XC1']['20'] }} :</label>
						  		<hrms-dropdown  v-model="codtparg" 
                                  :options="arrCodtparg[nowLang]"
                                  v-validate="'required'"
                                  data-vv-value-path="inputValue"
                                  data-vv-name="codtparg"
                                  :has-error="errors.has('codtparg')" />
                  <div class="text-error" v-show="errors.has('codtparg')">{{errors.first('codtparg')}}</div>
						  	</div>

			        </div> 
			        <div class="col-xs-12 col-md-12">
			          <div class="form-group-button">
			            <div class="btn button-in-search bg-color-skin" @click="validatePopupApprove()"><i class="fa fa-search"></i> {{ labelsButton['search'] }}</div>
			          </div>
			        </div>
			      </div>   
					</div>

        	<div class="detail detail-responsive">
            <div id="accordion_popup">  
				      <div class="panel box-collapse border-color-skin">
				        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion_popup" href="#detail1_1">
				          <h3 class="box-title">
				            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRESH6XC1']['30'] }}
				          </h3>
				        </div>
				        <div id="detail1_1" class="panel-collapse collapse in tab-detail">
				          <div class="panel-body">

				            <hrms-table :columns="tab1PopupTable1" 
												:data="popupTab1.table1"
												:maxRowspan="maxRowspanPopupTable1" />

				          </div>
				        </div>
				      </div> 
				       
				      <div class="panel box-collapse border-color-skin">
				        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion_popup" href="#detail1_2">
				          <h3 class="box-title">
				            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRESH6XC2']['10'] }}
				          </h3>
				        </div>
				        <div id="detail1_2" class="panel-collapse collapse tab-detail">
				          <div class="panel-body">
				            <div class="detail-block">

				            	<hrms-table :columns="tab1PopupTable2" 
												:data="popupTab1.table2" />
				              
				            </div>
				          </div>
				        </div>
				      </div> 

				    </div>  
					</div>						
        </div>
	    </div>
    </div>
	</div>
</template>

<script>
export default {
  name: 'hres6ju-popup',
  data () {
    return {
      codtparg: ''
    }
  },
  created () {
    if (typeof this.arrCodtparg[this.nowLang][this.codtparg] === 'undefined') {
      this.codtparg = ''
    }
  },
  props: [ 'labels', 'data', 'tab1PopupTable1', 'popupTab1', 'tab1PopupTable2', 'maxRowspanPopupTable1', 'arrCodtparg', 'nowLang', 'receivedHres6juDetailPopup', 'codempid', 'descCodempid', 'labelsButton' ],
  computed: {
    descCodemid () {
      return this.codempid + ' - ' + this.descCodempid
    }
  },
  methods: {
    validatePopupApprove () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.receivedHres6juDetailPopup(this.popupParams())
        }
      })
    },
    popupParams () {
      return {
        p_codempid: this.codempid,
        p_codtparg: this.codtparg
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// popup.vue?3671f23c